module.exports = __webpack_public_path__ + "static/media/tractor-3.c8569052.png";